module.exports = __webpack_public_path__ + "img/whatsapp.d7f15503.svg";